module.exports = __webpack_public_path__ + "static/img/91-1.caeb4ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/91-1.jpg
// module id = Q4hD
// module chunks = 0